const CheckoutConstants = {
  identityDocument: {
    AR: 'D.N.I',
    UY: 'C.I',
    CL: 'R.U.T',
    MX: 'CURP',
    CO: 'CC/CE',
    US: 'I.D',
    ES: 'D.N.I/N.I.E',
    BR: 'RG',
    PE: 'D.N.I/C.E',
  },
}

export default CheckoutConstants
